import { AcceptanceStatus, KycEventLogAction } from '@dealstack/shared/lib/generated';

// values will be mapped in translation files - mip-manage.kyc.history.action
export const mapHistoryAction = (action: KycEventLogAction, status: AcceptanceStatus) => {
	switch (action) {
		case KycEventLogAction.DELETED:
			return 'deleted';
		case KycEventLogAction.REVIEWED:
			if (status === AcceptanceStatus.APPROVED) {
				return 'accepted';
			}
			if (status === AcceptanceStatus.REJECTED || status === AcceptanceStatus.REREQUESTED) {
				return 'rejected';
			}
			if (status === AcceptanceStatus.PENDING) {
				return 'unaccepted';
			}
			return 'reviewed';
		case KycEventLogAction.SUBMITTED:
			return 'submitted';
		case KycEventLogAction.ADDITIONAL_FILE_REQUESTED:
			return 'additional_file_requested';
		case KycEventLogAction.ADDITIONAL_FILE_REQUEST_CANCELLED:
			return 'additional_file_cancelled';
		case KycEventLogAction.CERTIFICATION_ATTESTED:
			return 'certification_attested';
		case KycEventLogAction.CERTIFIER_NOMINATED:
			return 'certifier_nominated';
		case KycEventLogAction.CERTIFIED:
			return 'certified';
		case KycEventLogAction.CERTIFICATION_CANCELLED:
			return 'certification_cancelled';
	}
};
